import { type ElementType, Fragment } from 'react';
import { Menu } from '@mantine/core';
import { Item, type ItemType } from './components';

type ItemsProps<C extends ElementType = ElementType> = {
    items: ItemType<C>[];
};

export const Items = <C extends ElementType = ElementType>({ items }: ItemsProps<C>) => {
    return (
        <Menu.Dropdown>
            {items.map((item) => {
                return (
                    <Fragment key={item.title}>
                        {item.dividerBefore && <Menu.Divider />}

                        <Item {...item} />
                    </Fragment>
                );
            })}
        </Menu.Dropdown>
    );
};
